import { AuthenticatedFetch, CreateAuthHeader } from "../utils/Helpers";
import { IExportRequest } from "./ExportService";

export class ShareControlService
{
    private controller = "api/sharecontrol";

    public async Create(payload: IExportRequest): Promise<File> 
    {
        const requestOptions = {
            method: 'POST',
            headers: CreateAuthHeader(),
            body: JSON.stringify(payload)
        };
        
        const response = await AuthenticatedFetch(this.controller, requestOptions);
        if(!response.ok)
        {
            throw new Error("Export not working");
        }

        const blob = await response.blob();
        const filename = response.headers.get("X-Filename") || "Anpartskontrol.xlsm";        
        return new File([blob], filename, { type: blob.type });
    }
}